module.exports = __webpack_public_path__ + "img/setting.16727f7a.svg";